module.exports = __webpack_public_path__ + "img/wp-new-habit-card20.cc970113.png";